/**
 * External Dependencies
 */
import 'jquery';

const slugify = require('slugify');

/**
 * Cookies set get and delete
 */
function setCookie(name, value, days) {
  let d = new Date;
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function getCookie(name) {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function deleteCookie(name) { setCookie(name, '', -1); }

/**
 * Toggle style
 */

function toggleStyle(el, styleName, value) {
  if (el.style[styleName] !== value) {
    el.style[styleName] = value;
  } else {
    el.style[styleName] = '';
  }
}

/**
 * Toggle multiple classes
 */

function toggleClasses(selector, classes) {
  selector = selector || '';
  classes = classes || '';
  if (
    typeof selector == 'string'
    &&
    (typeof classes == 'string' || Array.isArray(classes))
    &&
    classes.length // true if either string or array not empty
    &&
    (selector = document.querySelector(selector))
  ) {
    var classList = selector.classList;
    if (!Array.isArray(classes)) {
      classes = classes.replace(/(,\s*|\s+)/g, ' ').split(' ');
    }
    for (var className of classes) {
      classList.toggle(className);
    }
    return true;
  }
}

/**
 * get all siblings
 */

const getSiblings = function (elem) {
  return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
    return sibling !== elem;
  });
};

/**
 * Animation check
 */

let isAnimating = false;

$(document).ready(() => {

  /**
   * restyle lists when headers are used instead of body copy
   */

  const blocksContainer = document.getElementById('blocks');
  let ul = blocksContainer.querySelectorAll('ul');

  if (ul) {
    ul.forEach(function (i) {
      i.querySelectorAll('li').forEach(function (li) {

        if (li.querySelector('h4')) {
          li.classList.add('text-36');
        }
      });
    });
  }

  /**
   * Mobile menu open and style changing
   */
  const mobBurger = document.getElementById('mobBurger');
  const mainNav = document.getElementById('mainNav');
  const firstBurgerLine = mobBurger.querySelector('span');
  const middleBurgerLine = firstBurgerLine.nextElementSibling;
  const lastBurgerLine = firstBurgerLine.nextElementSibling.nextElementSibling;

  mobBurger.addEventListener('click', () => {
    mainNav.classList.toggle('hidden');
    mainNav.classList.toggle('block');

    firstBurgerLine.classList.toggle('-rotate-45');
    toggleStyle(firstBurgerLine, 'width', '90%');

    middleBurgerLine.classList.toggle('opacity-0');

    lastBurgerLine.classList.toggle('rotate-45');

    toggleStyle(lastBurgerLine, 'width', '90%');

    toggleClasses('#topHeader', 'hidden block absolute top-full pt-24 z-10 px-24 bg-white w-full right-0 left-0 h-160');
  });

  /**
   * Add form placeholder - not required?
   */

  // const form = document.querySelector('.af-form');
  //
  // if (form) {
  //   let formFields = document.querySelectorAll('.af-field');
  //
  //   formFields.forEach(function (field ) {
  //     let afinput = field.querySelector('.af-input');
  //     let textarea = field.querySelector('.af-input textarea');
  //     let label = afinput.closest('.af-label').textContent;
  //
  //     if(textarea) textarea.setAttribute('placeholder',label);
  //     else afinput.querySelector('input').setAttribute('placeholder',label);
  //   });
  //
  // }

  /**
   * Wraps second submenu in main nav in div
   */
  const secondSubMenu = document.querySelectorAll('.sub-menu > li > .sub-menu');

  secondSubMenu.forEach(function (menu) {

    menu.insertAdjacentHTML('afterend', '<div class="secondarySubMenu"></div>');

    let parent = menu.parentElement;

    let newSubmenu = parent.querySelector('.secondarySubMenu');

    newSubmenu.appendChild(menu);
  });

  /**
   * prevent Dummy link clicks and add active class to required items for first solutions submenu
   */

  const solutionsMenu = document.querySelector('.solutionsMenu');

  solutionsMenu.querySelector('.sub-menu').classList.add('text-54', 'p-0', 'scale-100', 'mt-24', 'transform-origin-top', 'opacity-0', 'transition', 'list-none', 'rounded-sm', 'z-40', '1024:text-left', '1024:absolute', '1024:top-full', '1024:left-1/2', '1024:transform', '1024:-translate-x-1/2', '1024:gradient', '1024:shadow', '1024:p-54', '1024:mt-54', '1024:text-36')

  solutionsMenu.insertAdjacentHTML('afterbegin', '<span class="solutionsLine hidden 1024:block absolute top-full bottom-0 left-1/2 transform -translate-x-1/2 bg-orange w-3 opacity-0 transition-bottom transition-opacity"></span>')

  document.querySelectorAll('.solutionsMenu > .sub-menu > li:not(:last-child)').forEach(link => link.classList.add('mb-10'));

  const solutionsSubMenu = document.querySelector('.solutionsMenu > .sub-menu');

  document.querySelectorAll('.solutionsMenu > .sub-menu > li > a').forEach(link => link.classList.add('text-white', 'font-bold', 'whitespace-nowrap', 'text-left', 'normal-case', 'transition', 'hover:text-black'));

  document.querySelector('.solutionsMenu a').addEventListener('click', (e) => {

    e.preventDefault();

    solutionsSubMenu.classList.toggle('hidden');
    solutionsSubMenu.classList.toggle('block');

    toggleClasses('.solutionsMenu > .sub-menu', 'opacity-0');
    toggleClasses('.solutionsMenu > .sub-menu', 'opacity-1');

    toggleClasses('.solutionsLine', 'bottom-0 opacity-0');
    toggleClasses('.solutionsLine', '-bottom-54 opacity-1');


  });

  /**
   * Display second sub-menu and apply relevant classes
   */

  const whiteMenu = document.querySelectorAll('.secondarySubMenu');

  whiteMenu.forEach(function (menu) {
    menu.classList.add('w-full', 'mt-24', 'hidden', 'rounded-sm', 'transition', '1024:bg-white', '1024:absolute', '1024:left-full', '1024:shadow', '1024:mt-0', '1024:top-0', '1024:bottom-0', '1024:min-w-max', 'h-fit-content', 'min-h-full');

    menu.querySelector('ul').classList.add('list-none', 'mt-0');

    menu.querySelectorAll('a').forEach(link => link.classList.add('text-white', 'text-36', 'font-light', 'whitespace-nowrap', 'text-right', 'normal-case', 'transition', 'hover:text-black', '1024:text-left', '1024:text-black', '1024:hover:text-orange', '1024:text-24'));

    menu.querySelector('.sub-menu').classList.add('text-24', '1024:p-54', 'grid', 'grid-cols-1', '1024:grid-cols-2', 'gap-24', 'transition');
  });

  const landingpage = document.querySelectorAll('.landing-page');

  landingpage.forEach(function (link) {
    link.classList.add('col-span-full', '1024:font-bold');
    link.querySelector('a').classList.remove('font-light');
    link.querySelector('a').classList.add('font-bold');
  });

  const submenuLink = solutionsMenu.querySelectorAll('.sub-menu > li');

  submenuLink.forEach(function (link) {
    link.addEventListener('click', () => {

      let currentActive = document.querySelector('.secondarySubMenu.block');

      if (currentActive) {
        currentActive.classList.remove('block');
        currentActive.classList.add('hidden');
        currentActive.querySelector('.sub-menu').classList.remove('block');
        currentActive.querySelector('.sub-menu').classList.add('hidden');
      }

      link.querySelector('.secondarySubMenu').classList.add('block');
      link.querySelector('.secondarySubMenu').classList.remove('hidden');
      link.querySelector('.secondarySubMenu .sub-menu').classList.add('block');
      link.querySelector('.secondarySubMenu .sub-menu').classList.remove('hidden');

      let siblings = getSiblings(link);

      siblings.forEach(sib => sib.style.opacity = '0.5');

      link.style.opacity = '1';
    })
  });

  const productOptions = document.getElementById('productOptions');

  if (productOptions) {

    const productOptionsTitles = productOptions.querySelectorAll('h2');

    productOptionsTitles.forEach(function (title) {
      title.addEventListener('click', (el) => {

        //stop click spam
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        setTimeout(function () {
          isAnimating = false;
        }, 200);

        //show and hide titles

        el.target.classList.remove('1024:opacity-30');

        el.target.querySelector('span').classList.remove('w-160');
        el.target.querySelector('span').classList.add('w-11/12');

        let sibs = getSiblings(el.target);

        sibs.forEach(function (sib) {
          if (sib.classList.contains('1024:cursor-pointer')) {
            sib.classList.add('1024:opacity-30')
            sib.querySelector('span').classList.remove('w-11/12');
            sib.querySelector('span').classList.add('w-160');
          }
        });

        //display text box
        let titleID = el.target.id;
        const textBox = document.getElementById(titleID + 'Info')
        textBox.classList.add('block');
        textBox.classList.remove('hidden');

        let textBoxSibs = getSiblings(textBox);

        textBoxSibs.forEach(function (sib) {
          if (sib.classList.contains('block')) {
            sib.classList.add('hidden');
            sib.classList.remove('block');
          }
        });

      });
    });

    document.getElementById('application').click()
  }

  /**
   * Video modal
   */

  const videoContainer = document.getElementById('videoContainer');
  const playVideo = document.getElementById('playVideo');
  const playIcon = document.getElementById('playIcon');
  const closeVideo = document.getElementById('closeVideo');
  const videoWrapper = document.getElementById('videoWrapper');

  if (playVideo) {
    playVideo.addEventListener('click', (el) => {
      document.body.appendChild(videoContainer);
      videoContainer.classList.remove('opacity-0', 'invisible');
      videoContainer.classList.add('opacity-100', 'visible');
    });

    playIcon.addEventListener('click', (el) => {
      document.body.appendChild(videoContainer);
      videoContainer.classList.remove('opacity-0', 'invisible');
      videoContainer.classList.add('opacity-100', 'visible');
    });

    closeVideo.addEventListener('click', (el) => {
      videoContainer.classList.add('opacity-0', 'invisible');
      videoContainer.classList.remove('opacity-100', 'visible');

      videoWrapper.appendChild(videoContainer);
    });
  }

  /**
   * Solutions smart letters
   */

  const smartLetters = document.querySelectorAll('.smartLetter');
  const firstSmartLetter = document.querySelector('div.smartLetter');

  if (firstSmartLetter) {
    smartLetters.forEach(function (letter) {
      letter.addEventListener('click', (el) => {
        el.stopPropagation();
        if (el.target !== el.currentTarget) return;
        let $this = el.currentTarget;
        $this.classList.remove('gradient');
        $this.querySelector('span').classList.remove('text-white')
        $this.classList.add('bg-white', 'border', 'border-orange');
        $this.querySelector('span').classList.add('text-orange')

        $this.querySelector('.line').classList.remove('h-0');
        $this.querySelector('.line').classList.add('h-54');

        $this.querySelector('div').classList.remove('invisible', 'opacity-0');
        $this.querySelector('div').classList.add('visible', 'opacity-100');

      });
    });

    const closeLetter = document.querySelectorAll('.closeLetter');

    closeLetter.forEach(function (close) {
      close.addEventListener('click', (el) => {
        let $this = el.target.closest('.smartLetter');
        $this.classList.add('gradient');
        $this.querySelector('span').classList.add('text-white')
        $this.classList.remove('bg-white', 'border', 'border-orange');
        $this.querySelector('span').classList.remove('text-orange')

        $this.querySelector('.line').classList.add('h-0');
        $this.querySelector('.line').classList.remove('h-54');

        $this.querySelector('div').classList.add('invisible', 'opacity-0');
        $this.querySelector('div').classList.remove('visible', 'opacity-100');
      });
    });
  }

  /**
   * solutions tabs
   */

  const tabInfoWrapper = document.getElementById('tabInfoWrapper');
  const icons = document.getElementById('icons');

  if (tabInfoWrapper) {
    const iconWrapper = icons.querySelectorAll('.iconWrapper');

    iconWrapper.forEach(function (icon) {
      let img = icon.querySelector('img');
      let line = icon.querySelector('.tabline');

      img.addEventListener('click', () => {

        let info = document.querySelector('.' + img.id);
        let activeInfo = document.querySelector('.activeInfo');

        if (activeInfo) {
          activeInfo.classList.remove('grid', 'activeInfo');
          activeInfo.classList.add('hidden');
        }

        if (img.classList.contains('active')) {
          img.classList.remove('active');
          line.classList.remove('h-54')
          line.classList.add('h-0');
          info.classList.add('hidden');
          info.classList.remove('grid', 'activeInfo');
        } else {

          iconWrapper.forEach(function (icon) {
            if (icon.querySelector('.active')) {
              icon.querySelector('.active').classList.remove('active');
              icon.querySelector('.tabline').classList.remove('h-54');
              icon.querySelector('.tabline').classList.add('h-0');
            }
          });

          // slideDown(tabInfoWrapper);
          img.classList.add('active');
          line.classList.add('h-54')
          line.classList.remove('h-0')
          info.classList.remove('hidden');
          info.classList.add('grid', 'activeInfo');
        }
      });
    });

    //apply ID

    const solutionsText = document.querySelectorAll('.solutionsText');
    solutionsText.forEach(function (i) {
      i.parentElement.id = slugify(i.querySelector('h2').textContent);
    });

    //get url parameters
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    const tab = urlParams.get('tab')

    if (tab) {
      let targetTab = document.getElementById(tab);
      targetTab.classList.remove('hidden');
      targetTab.classList.add('grid', 'activeInfo');
      targetTab.scrollIntoView({
        behavior: 'smooth',
      });
    }

    //click on page load if tab parameter doesn't exist
    if (!tab) {
      icons.querySelector('.iconWrapper img').click();
    }
  }

  /**
   * product carousel spinner
   */

  const productCarousel = document.getElementById('productCarousel');

  if (productCarousel) {
    const productNav = document.getElementById('productNav');
    const productInfo = document.getElementById('productInfo');
    const productImages = document.getElementById('productImages');

    const next = productNav.querySelector('.next');
    const prev = document.querySelector('.previous');
    const spinner = document.getElementById('spinner').querySelector('svg');
    let degrees = 0;

    next.addEventListener('click', () => {
      let image = productImages.querySelector('div');
      productInfo.appendChild(productInfo.querySelector('div'));
      degrees -= 45;
      spinner.style.transform = 'rotate(' + degrees + 'deg)';
      productImages.appendChild(image);
    });
    prev.addEventListener('click', () => {
      let image = productImages.querySelector('div:last-child');
      productInfo.prepend(productInfo.querySelector('div:last-child'));
      degrees += 45;
      spinner.style.transform = 'rotate(' + degrees + 'deg)';
      productImages.prepend(image);
    });
  }

  /**
   * downloads filter
   */

  const downloadFilter = document.getElementById('downloadFilter');
  const downloadList = document.getElementById('downloadList');

  if (downloadFilter) {
    downloadFilter.querySelectorAll('span').forEach(function (cat) {
      cat.addEventListener('click', () => {
        cat.classList.remove('text-midgrey');
        cat.classList.add('text-orange');

        let sibs = getSiblings(cat);
        sibs.forEach(function (sib) {
          sib.classList.add('text-midgrey');
          sib.classList.remove('text-orange');
        });

        downloadList.querySelectorAll('.all').forEach(function (download) {
          if (download.classList.contains(cat.id)) {
            download.classList.remove('hidden');
            download.classList.add('block');
          } else {
            download.classList.add('hidden');
            download.classList.remove('block');
          }
        });
      });
    });
  }

  /**
   * Case studies filter
   */

  const caseStudyLocationFilter = document.getElementById('caseStudyLocationFilter');
  const caseStudyProductFilter = document.getElementById('caseStudyProductFilter');
  const caseStudyList = document.getElementById('caseStudyList');

  if (caseStudyList) {
    caseStudyLocationFilter.querySelectorAll('span').forEach(function (cat) {
      cat.addEventListener('click', () => {
        cat.classList.remove('text-midgrey');
        cat.classList.add('text-orange');

        let sibs = getSiblings(cat);
        sibs.forEach(function (sib) {
          sib.classList.add('text-midgrey');
          sib.classList.remove('text-orange');
        });

        let product = caseStudyProductFilter.querySelector('.text-orange').id;

        caseStudyList.querySelectorAll('.all').forEach(function (post) {
          if (post.classList.contains(cat.id) && post.classList.contains(product)) {
            post.classList.remove('hidden');
            post.classList.add('block');
            post.classList.add('activeLocation');
          } else {
            post.classList.add('hidden');
            post.classList.remove('block');
            post.classList.remove('activeLocation');
          }
        });
      });
    });

    caseStudyProductFilter.querySelectorAll('span').forEach(function (cat) {
      cat.addEventListener('click', () => {
        cat.classList.remove('text-midgrey');
        cat.classList.add('text-orange');

        let sibs = getSiblings(cat);
        sibs.forEach(function (sib) {
          sib.classList.add('text-midgrey');
          sib.classList.remove('text-orange');
        });

        let location = caseStudyLocationFilter.querySelector('.text-orange').id;

        caseStudyList.querySelectorAll('.all').forEach(function (post) {
          if (post.classList.contains(cat.id) && post.classList.contains(location)) {
            post.classList.remove('hidden');
            post.classList.add('block');
            post.classList.add('activeLocation');
          } else {
            post.classList.add('hidden');
            post.classList.remove('block');
            post.classList.remove('activeLocation');
          }
        });
      });
    });
  }

  /**
   * Case study carousel scripting
   */

  const caseStudyImages = document.getElementById('caseStudyImages');
  const caseStudyInfo = document.getElementById('caseStudyInfo');
  const caseStudyNav = document.getElementById('caseStudyNav');
  const imageBin = document.getElementById('imageBin');

  if (caseStudyImages) {
    // set image styling
    let firstImage = caseStudyImages.querySelector('div');
    let secondImage = firstImage.nextElementSibling;
    let thirdImage = secondImage.nextElementSibling;
    let fourthImage = thirdImage.nextElementSibling;

    const allImages = caseStudyImages.querySelectorAll('div')

    allImages.forEach(function (img) {
      img.style.cssText = 'opacity: 0!important; transform:scale(0.6561) !important; z-index:0 !important; left: 42.5rem !important;';
    });

    firstImage.style.cssText = 'opacity: 1 !important; transform:scale(1)!important; z-index:40 !important; right: auto !important';

    secondImage.style.cssText = 'opacity: 0.75 !important; transform:scale(0.9)!important; z-index:30 !important; left: 16rem !important; right: auto !important';

    thirdImage.style.cssText = 'opacity: 0.5 !important; transform:scale(0.81)!important; z-index:20 !important;  left: 30rem !important; right: auto !important';

    fourthImage.style.cssText = 'opacity: 0.25 !important; transform:scale(0.729)!important; z-index:10 !important; left: 42.5rem !important; right: auto !important';


    //set button vars
    const next = caseStudyNav.querySelector('.next');
    const prev = caseStudyNav.querySelector('.previous');

    //click animation for next button
    next.addEventListener('click', () => {

      //stop click spam
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      setTimeout(function () {
        isAnimating = false;
      }, 500);

      //do animation and stuff

      let firstImage = caseStudyImages.querySelector('div');
      let secondImage = firstImage.nextElementSibling;
      let thirdImage = secondImage.nextElementSibling;
      let fourthImage = thirdImage.nextElementSibling;

      firstImage.style.cssText = 'opacity: 0 !important; transform:scale(0.6561)!important; z-index:0 !important; left: 42.5rem !important; right: 100% !important';

      setTimeout(function () {
        caseStudyImages.appendChild(firstImage);
      }, 500);


      secondImage.style.cssText = 'opacity: 1 !important; transform:scale(1)!important; z-index:40 !important; right: auto !important;';

      thirdImage.style.cssText = 'opacity: 0.75 !important; transform:scale(0.9)!important; z-index:30 !important; left: 16rem !important; right: auto !important';

      fourthImage.style.cssText = 'opacity: 0.5 !important; transform:scale(0.81)!important; z-index:20 !important;  left: 30rem !important; right: auto !important';

      fourthImage.nextElementSibling.style.cssText = 'opacity: 0.25 !important; transform:scale(0.729)!important; z-index:10 !important; left: 42.5rem !important; right: auto !important';

      //info switcher

      caseStudyInfo.appendChild(caseStudyInfo.querySelector('div'));
    });

    //animation to go backwards
    prev.addEventListener('click', () => {
      //stop click spam
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      setTimeout(function () {
        isAnimating = false;
      }, 500);

      //do animation and stuff
      let firstImage = caseStudyImages.querySelector('div');
      let secondImage = firstImage.nextElementSibling;
      let thirdImage = secondImage.nextElementSibling;
      let fourthImage = thirdImage.nextElementSibling;
      let lastImage = caseStudyImages.lastElementChild;

      firstImage.style.cssText = 'opacity: 0.75 !important; transform:scale(0.9)!important; z-index:30 !important; left: 16rem !important; right: auto !important';

      secondImage.style.cssText = 'opacity: 0.5 !important; transform:scale(0.81)!important; z-index:20 !important;  left: 30rem !important; right: auto !important';

      thirdImage.style.cssText = 'opacity: 0.25 !important; transform:scale(0.729) !important; z-index:10 !important; left: 42.5rem !important; right: auto !important';

      fourthImage.style.cssText = 'opacity: 0 !important; transform:scale(0.6561)!important; z-index:0 !important; left: 0 !important; right: 100% !important; right: auto !important';

      lastImage.style.cssText = 'opacity: 1 !important; transform:scale(1)!important; z-index:40 !important; right: auto !important;';

      setTimeout(function () {
        caseStudyImages.prepend(lastImage);
      }, 500);

      //info switcher
      caseStudyInfo.prepend(caseStudyInfo.lastElementChild);
    });
  }

  /**
   * Custom search
    */

  // gets the text input as a variable.
  const SearchInput = document.getElementById("custom-search-input");

  // gets an array of all of the certification blocks.
  const searchBlock = document.querySelectorAll(".searchable-block");

  const keyupFunction = () => {
    // gets the search input value as a lowercase string.
    const searchValue = SearchInput.value.toLowerCase();

    searchBlock.forEach(block => {
      // gets the title of each certification block as a lowercase string.
      const blockTitle = block.textContent.trim().toLowerCase();
      if (blockTitle.indexOf(searchValue) !== -1) {
        // if the block title contains the search value show block.
        block.classList.add("block")
        block.classList.remove("hidden")
        // else hide block.
      } else {
        block.classList.add("hidden")
        block.classList.remove("block")
      }
    });

  }

  document.addEventListener('keyup', keyupFunction);


  /**
   * scroll anchor links
   */
  document.querySelectorAll('a[href^="#"].scrollto').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      });
    });
  });

  /**
   * Gallery
   */

  const gallery = document.getElementById('gallery');

  function imageStyling(image, index, all) {
    //Style images based on dom position
    image.style.cssText = 'opacity: 0 !important; transform:scale(0.4)!important; z-index:10 !important;  left: 0 !important; right: 0 !important; transform-origin: centre !important;';

    if (index === 0) {
      image.style.cssText = 'opacity: 1 !important; transform:scale(1)!important; z-index:50 !important;  left: 0 !important; right: 0 !important; transform-origin: center !important;';
    }
    if (index === 1) {
      image.style.cssText = 'opacity: 0.6 !important; transform:scale(0.8)!important; z-index:30 !important;  left: auto !important; right: -3.375rem !important;transform-origin: right !important;';
    }
    if (index === 2) {
      image.style.cssText = 'opacity: 0.3 !important; transform:scale(0.6)!important; z-index:10 !important;  left: auto !important; right: -5.625rem !important;transform-origin: right !important;';
    }
    if (index === all.length - 1) {
      image.style.cssText = 'opacity: 0.6 !important; transform:scale(0.8)!important; z-index:30 !important;  left: -3.375rem !important; right: auto !important; transform-origin: left !important;';
    }
    if (index === all.length - 2) {
      image.style.cssText = 'opacity: 0.3 !important; transform:scale(0.6)!important; z-index:10 !important; left: -5.625rem !important; right: auto!important; transform-origin: left !important;';
    }
  }

  function nextStyling(image, index, all) {
    //Style images based on dom position
    image.style.cssText = 'opacity: 0 !important; transform:scale(0.4)!important; z-index:10 !important;  left: 0 !important; right: 0 !important; transform-origin: centre !important;';

    if (index === 1) {
      image.style.cssText = 'opacity: 1 !important; transform:scale(1)!important; z-index:50 !important;  left: 0 !important; right: 0 !important; transform-origin: center !important;';
    }
    if (index === 2) {
      image.style.cssText = 'opacity: 0.6 !important; transform:scale(0.8)!important; z-index:30 !important;  left: auto !important; right: -3.375rem !important;transform-origin: right !important;';
    }
    if (index === 3) {
      image.style.cssText = 'opacity: 0.3 !important; transform:scale(0.6)!important; z-index:10 !important;  left: auto !important; right: -5.625rem !important;transform-origin: right !important;';
    }
    if (index === 0) {
      image.style.cssText = 'opacity: 0.6 !important; transform:scale(0.8)!important; z-index:30 !important;  left: -3.375rem !important; right: auto!important; transform-origin: left !important;';
    }
    if (index === all.length - 1) {
      image.style.cssText = 'opacity: 0.3 !important; transform:scale(0.6)!important; z-index:10 !important; left: -5.625rem !important; right: auto!important; transform-origin: left !important;';
    }
  }

  function prevStyling(image, index, all) {
    //Style images based on dom position
    image.style.cssText = 'opacity: 0 !important; transform:scale(0.4)!important; z-index:10 !important;  left: 0 !important; right: 0 !important; transform-origin: centre !important;';

    if (index === all.length - 1) {
      image.style.cssText = 'opacity: 1 !important; transform:scale(1)!important; z-index:50 !important;  left: 0 !important; right: 0 !important; transform-origin: center !important;';
    }
    if (index === 0) {
      image.style.cssText = 'opacity: 0.6 !important; transform:scale(0.8)!important; z-index:30 !important;  left: auto !important; right: -3.375rem !important;transform-origin: right !important;';
    }
    if (index === 1) {
      image.style.cssText = 'opacity: 0.3 !important; transform:scale(0.6)!important; z-index:10 !important;  left: auto !important; right: -5.625rem !important;transform-origin: right !important;';
    }
    if (index === all.length - 2) {
      image.style.cssText = 'opacity: 0.6 !important; transform:scale(0.8)!important; z-index:30 !important;  left: -3.375rem !important; right: auto!important; transform-origin: left !important;';
    }
    if (index === all.length - 3) {
      image.style.cssText = 'opacity: 0.3 !important; transform:scale(0.6)!important; z-index:10 !important; left: -5.625rem !important; right: auto!important; transform-origin: left !important;';
    }
  }


  function imageCountCheck(images) {
    //Check if images are less than 5
    if (images.length < 7) {
      //if less than 5, clone and append to parent
      images.forEach(function (image) {
        let clone = image.cloneNode(true);
        let imagesParent = image.parentElement;
        imagesParent.appendChild(clone);
      });
      //get new list of images
      let newImages = gallery.querySelectorAll('.image');
      if (images.length < 7) {
        imageCountCheck(newImages);
      } else {
        //apply styling
        newImages.forEach(imageStyling);
      }
    }
    else {
      images.forEach(imageStyling);
    }
  }

  if (gallery) {
    //get images
    let images = gallery.querySelectorAll('.image');
    //run image count check function
    imageCountCheck(images);

    const next = document.getElementById('galleryNav').querySelector('.next');
    const prev = document.getElementById('galleryNav').querySelector('.previous');

    next.addEventListener('click', function () {

      //stop click spam
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      setTimeout(function () {
        isAnimating = false;
      }, 200);

      let currentImage = gallery.querySelector('.image');

      let images = gallery.querySelectorAll('.image');

      images.forEach(nextStyling);

      setTimeout(function () {
        currentImage.parentElement.appendChild(currentImage);
      }, 1100);

    });

    prev.addEventListener('click', function () {

      //stop click spam
      if (isAnimating) {
        return;
      }

      isAnimating = true;

      setTimeout(function () {
        isAnimating = false;
      }, 200);

      let lastImage = gallery.querySelector('.image:last-child');

      let images = gallery.querySelectorAll('.image');

      images.forEach(prevStyling);

      setTimeout(function () {
        lastImage.parentElement.prepend(lastImage);
      }, 1100);
    });
  }
});


/**
 * office location changer
 */

const officeLocationsSelect = document.getElementById('officeLocationsSelect');

if (officeLocationsSelect) {
  officeLocationsSelect.addEventListener('change', () => {
    console.log(officeLocationsSelect.value);
    let infoBox = document.getElementById(officeLocationsSelect.value);
    infoBox.classList.add('block');
    infoBox.classList.remove('hidden');

    let sibs = getSiblings(infoBox);
    sibs.forEach(function (sib) {
      sib.classList.add('hidden');
      sib.classList.remove('block');
    });
  });
}


/**
 * Language and location selector
 */

const locationChange = document.getElementById('locationChange');

locationChange.addEventListener('click', function () {
  let location = document.getElementById('country').value;
  let language = document.getElementById('language').value;

  function locationScript() {
    if (location !== 'noLoc') {
      deleteCookie('User Location')
      setCookie('User Location', location);
    }
  }

  if (language) {
    locationScript();
    window.location = language;
  } else {
    locationScript();
    window.location.reload();
  }

});

if (getCookie('User Location')) {
  document.getElementById('country').value = getCookie('User Location');
}

/**
 * Testimonials carousel
 */

const testimonialList = document.getElementById('testimonialList');

if (testimonialList) {
  const buttons = document.getElementById('buttons');

  buttons.querySelectorAll('span').forEach(function (button) {
    button.addEventListener('click', function () {

      //change button classes
      button.classList.remove('bg-orange');
      button.classList.add('bg-black');

      //change sibling classes
      let sibs = getSiblings(button);
      sibs.forEach(function (sib) {
        sib.classList.add('bg-orange');
        sib.classList.remove('bg-black');
      });

      //get related testimonial and move to front to display
      let testimonial = testimonialList.querySelector('.' + button.id);
      testimonialList.prepend(testimonial);
    });
  });

  buttons.querySelector('span').click();
}

/**
 * Form action replacements
 */

const projectquestionnaire = document.querySelector('.project-questionnaire');

if (projectquestionnaire) {

  const language = getCookie('wp-wpml_current_language');

  if (language == 'fr') {
    document.getElementById('form_60eda07e8c831').action = 'https://www2.pyroguard.eu/l/64652/2021-12-17/h9yjs4';
  }

  if (language == 'nl') {
    document.getElementById('form_60eda07e8c831').action = 'https://www2.pyroguard.eu/l/64652/2021-12-17/h9yjsl';
  }

  if (language == 'es') {
    document.getElementById('form_60eda07e8c831').action = 'https://www2.pyroguard.eu/l/64652/2021-12-17/h9yjsn';
  }

  if (language == 'de') {
    document.getElementById('form_60eda07e8c831').action = 'https://www2.pyroguard.eu/l/64652/2021-12-17/h9yjsx';
  }

  if (language == 'it') {
    document.getElementById('form_60eda07e8c831').action = 'https://www2.pyroguard.eu/l/64652/2021-12-17/h9yjsz';
  }

  if (!language || language == 'en') {
    document.getElementById('form_60eda07e8c831').action = 'https://www2.pyroguard.eu/l/64652/2021-12-17/h9yhzb';
  }

}

/**
 * cookie notice
 */

const notice = document.getElementById("cookieNotice");

if (notice) {

  if (!getCookie('cookie-banner')) {
    console.log('no consent');
    notice.classList.remove('hidden');
    notice.classList.add('block');
  }
  else {
    console.log('consent');
  }

  notice.querySelector('button').addEventListener('click', function () {
    notice.classList.add('hidden');
    notice.classList.remove('block');
    setCookie('cookie-banner', 'consent', '7')
  });
}